<template>
  <f7-app v-bind="f7params">
    <Dialog
      :header="dialogTitle"
      v-model:visible="isDialogVisible"
      :style="{width: '350px'}"
      class="z-index-999999"
      :modal="true"
    >
      <p class="p-mb-0" v-html="dialogText"></p>

      <template #footer>
        <Button
          :label="$t('OK')"
          icon="pi pi-check"
          autofocus
          class="p-m-0"
          @click="isDialogVisible=false"
        />
      </template>
    </Dialog>

    <Dialog
      :header="promptTitle"
      v-model:visible="isPromptVisible"
      :style="{width: '350px'}"
      class="z-index-999999"
      :modal="true"
    >
      <p v-html="promptText"></p>

      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="isPromptVisible = false"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          autofocus
          @click="promptConfirmCallback(); isPromptVisible = false"
        />
      </template>
    </Dialog>

    <Toast class="z-index-999999" />

    <f7-popup
      :close-by-backdrop-click="false"
      :close-on-escape="false"
      v-model:opened="isRoutablePopupBigOpened"
      @popup:closed="onCloseHelperPopupBig"
      class="dialog-content-overflow-visible popup-big"
    >
      <f7-view name="routablePopupBig" :load-initial-page="false"></f7-view>
    </f7-popup>

    <f7-popup
      :close-by-backdrop-click="false"
      :close-on-escape="false"
      v-model:opened="isRoutablePopupOpened"
      @popup:closed="onCloseHelperPopup"
      class="dialog-content-overflow-visible"
    >
      <f7-view name="routablePopup" :load-initial-page="false"></f7-view>
    </f7-popup>

    <!-- Your main view, should have "view-main" class -->
    <f7-view main class="safe-areas" url="/"></f7-view>
    <!--<f7-view main class="safe-areas" url="/" :push-state="true" :browser-history="true" browser-history-separator="#!" ></f7-view>-->
    <!--<f7-view main class="safe-areas" url="/" :browser-history="true" browser-history-separator="" browser-history-root="http://localhost:8080" ></f7-view>-->
  </f7-app>
</template>
<script>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { f7, f7ready } from "framework7-vue";
import { useI18n } from "vue-i18n";

import routes from "../js/routes.js";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

import Toast from "primevue/toast";
import ErrorService from "../service/error-service";
import { getParentUrl } from "../js/helper";
import ApiMethods from "../js/api-methods";

export default {
  components: {
    Dialog,
    Button,
    Toast
  },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    // Framework7 Parameters
    const f7params = {
      name: "Dashboard", // App name
      theme: "aurora", // Automatic theme detection
      view: {
        //pushState: true,
        /*browserHistory: true,
          pushStateOnLoad: false,
          browserHistoryInitialMatch: true,
          browserHistorySeparator: '#!',
          browserHistoryRoot: (function() {
            console.log(location)
            //return location.pathname;
            return "http://localhost:8080";
            //return "/dashboard/";
          })(),*/
        /* history: true,
          pushStateOnLoad: false,
          pushStateSeparator: '#',*/
        /*pushStateRoot: (function() {
            console.log(location.pathname)
            //return location.pathname;
            return "/dashboard/";
          })(),*/
      },
      // App routes
      routes: routes,

      on: {
        routeChange(newRoute, previousRoute, router) {
          console.log(newRoute);
        }
      }
    };

    const isDialogVisible = ref(false);
    const dialogTitle = ref();
    const dialogText = ref();
    let alert = computed(() => store.state.ALERT);
    watch(alert, alertDetails => {
      dialogTitle.value = alertDetails.title;
      dialogText.value = alertDetails.text;
      isDialogVisible.value = true;
    });

    let error = computed(() => store.state.ERROR);
    let errorService = new ErrorService();
    watch(error, err => {
      console.log(err);
      let msg = t("IssueDetected"); //"An issue has been detected, please try again later or contact our support team"
      switch (err.method) {
        case "SIM_SEND_COMMAND":
          if (err.MajorCode === "100") {
            msg = t("SIM_MANAGE_MSG015");
          }
          break;

        case "CUSTOMER_EDIT":
          if (err.MajorCode === "200") {
            msg = err?.Data?.error || t("IssueDetected");
            if (msg === "loginName incorrect") msg = t("LoginNameInUse");
            if (msg === "email incorrect") msg = t("EmailInUse");
          }
          break;
        case "SEND_CUSTOMER_REG_LETTER":
          if (err.MajorCode === "100") {
            msg = err?.Data || t("IssueDetected");
            if (msg === "CHECK DOMAIN SETTINGS")
              msg = t("CheckCustomerSettings");
          }
          break;
        case "IMPORT_ASSETS":
          if (err.MajorCode === "200") {
            msg = err?.Data || t("IssueDetected");
          }
          break;
        case "EDIT_ASSET":
          if (err.MajorCode === "200") {
            msg = err?.Data || t("IssueDetected");
          }
          break;
        case "SEND_ASSET_ACTIVATION_LETTER":
          msg = err?.Data || t("IssueDetected");
          if (msg === "Client type incorrect")
            msg = t("ActivationLetterErrorAccType");
          break;
      }

      dialogTitle.value = t("Error");
      dialogText.value = msg;
      isDialogVisible.value = true;

      if (err.saveError || err.sendErrorEmail) {
        let message =
          err.MajorCode && err.Data
            ? {
                MajorCode: err.MajorCode,
                MinorCode: err.MinorCode,
                Data: err.Data
              }
            : err;
        let data = {
          message: JSON.stringify(message),
          query: JSON.stringify(err.query),
          url: ApiMethods[err.method],
          domain: getParentUrl(),
          project: "qt-agent-portal"
        };
        if (err.saveError) {
          errorService.saveError(data);
        }
        if (err.sendErrorEmail) {
          data.recipients = "vladislav.biletskiy@sinopacificukraine.com"; //other emails can be added separated by ',' sign
          errorService.sendErrorOnEmail(data);
        }
      }
    });

    const isPromptVisible = ref(false);
    const promptTitle = ref();
    const promptText = ref();
    const promptConfirmCallback = ref();
    let prompt = computed(() => store.state.PROMPT);
    watch(prompt, promptDetails => {
      promptTitle.value = promptDetails.title;
      promptText.value = promptDetails.text;
      promptConfirmCallback.value = promptDetails.confirmCallback;
      isPromptVisible.value = true;
    });

    const isRoutablePopupOpenedStore = computed(
      () => store.state.isRoutablePopupOpened
    );
    const isRoutablePopupOpened = ref(false);
    const onCloseHelperPopup = () => {
      store.commit("SET_ROUTABLE_POPUP_STATE", false);
      f7.views.routablePopup.router.clearPreviousHistory();
    };
    watch(isRoutablePopupOpenedStore, isOpened => {
      isRoutablePopupOpened.value = isOpened;
    });

    const isRoutablePopupBigOpenedStore = computed(
      () => store.state.isRoutablePopupBigOpened
    );
    const isRoutablePopupBigOpened = ref(false);
    const onCloseHelperPopupBig = () => {
      store.commit("SET_ROUTABLE_POPUP_BIG_STATE", false);
      f7.views.routablePopupBig.router.clearPreviousHistory();
    };
    watch(isRoutablePopupBigOpenedStore, isOpened => {
      isRoutablePopupBigOpened.value = isOpened;
    });

    let dashboardUpdateInterval;
    const onMainRouteChanged = (newRoute, previousRoute, router) => {
      if (router.view.main) {
        if (dashboardUpdateInterval) clearInterval(dashboardUpdateInterval);
        //turn on dashboard auto update data if dashboard is opened
        //and turn it off if other pages are opened on main view
        if (newRoute.name === "dashboard") {
          dashboardUpdateInterval = setInterval(() => {
            let params = {
              MajorToken: store.getters.MajorToken,
              MinorToken: store.getters.MinorToken
            };
            store.dispatch("GET_DASHBOARD", params);
            store.dispatch("GET_USAGE_OVERVIEW", params);
          }, 60 * 2000);
        }
      }
    };

    onMounted(() => {
      f7ready(() => {
        //f7.on("routeChanged", onMainRouteChanged);

        let params = {};
        if (
          f7.views.main.router.currentRoute.query.MajorToken &&
          f7.views.main.router.currentRoute.query.MinorToken
        ) {
          params = {
            MajorToken: f7.views.main.router.currentRoute.query.MajorToken,
            MinorToken: f7.views.main.router.currentRoute.query.MinorToken
          };
        } else {
          /*params = {
              MajorToken: "aabc9ee0-b36d-4806-8e4d-b65899f7da7c",
              MinorToken: "196ee8a3-37f6-4438-bbee-3ba2f6264c36"
            }*/
        }

        if (params.MajorToken && params.MinorToken) {
          store.commit("SET_MAJOR_TOKEN", params.MajorToken);
          store.commit("SET_MINOR_TOKEN", params.MinorToken);
          // store.dispatch('SET_DASHBOARD', params)
          store.dispatch("GET_DASHBOARD", params);
          store.dispatch("GET_USAGE_OVERVIEW", params);
          //store.dispatch('GET_USER_INFO', {code: params.MinorToken})
          store.dispatch("GET_USER_INFO", {
            MajorToken: params.MajorToken,
            MinorToken: params.MinorToken,
            Code: params.MajorToken
          });
          store.dispatch("SIM_GET_COMMANDS", params);
          store.dispatch("GET_SOLUTIONS_AND_PRODUCTS", {
            DealerToken: params.MajorToken
          });
        }
        //console.log(f7.views.main.router.currentRoute)

        f7.views.main.router.navigate(
          {
            name: !f7.views.main.router.currentRoute.query.page
              ? "dashboard"
              : f7.views.main.router.currentRoute.query.page.toLowerCase()
          },
          { clearPreviousHistory: true }
        );
      });
    });

    return {
      f7params,
      error,

      isDialogVisible,
      dialogTitle,
      dialogText,

      isPromptVisible,
      promptTitle,
      promptText,
      promptConfirmCallback,

      isRoutablePopupOpened,
      onCloseHelperPopup,

      isRoutablePopupBigOpened,
      onCloseHelperPopupBig
    };
  }
};
</script>